import CetakPPA from './CetakPPA'

export default CetakPPA